import React from "react";
import Moment from "react-moment";
import { Translate } from "react-redux-i18n";
import { Icon } from "@blueprintjs/core";
import CircleImage from "../../Image/CircleImage";
export default function ConversationItem({ conversation, locale, onClick }) {
  const unread = conversation["unread"] ? "unread" : "";
  return (
    <div className={`item ${unread}`} onClick={_ => onClick(conversation)}>
      <div className="image">
        <CircleImage size="small" src={conversation["t_url"]} alt={conversation["title"]} />
      </div>
      <div className="meta">
        <div className="context">{conversation["title"]}</div>
        <div className="message">{conversation["last_message"] ? conversation["last_message"]["content"] : ""}</div>
        <div className="timestamp">
          <Moment locale={locale} fromNow ago>
            {conversation["c_at"]}
          </Moment>
          <Translate value="expenses.ago" />
        </div>
      </div>
      <Icon icon="chevron-right" iconSize="16" className="icon more-indicator" />
    </div>
  );
}
